<script>
import { readAllPosts } from '@/services/MindMovieServices';
import MindMovieLazySinglePost from '@/components/MindMovieLazySinglePost.vue';

export default {
  components: { MindMovieLazySinglePost },
  data() {
    return {
      uId: localStorage.getItem('uId'),
      token: localStorage.getItem('idToken'),

      pageView: '1',
      startPage: '1',

      showThisManyPostsAtATime: 15,

      rawPosts: [],
      allPosts: [],
    };
  },
  computed: {
    postsToDisplay() {
      const sliceStart = parseInt(this.showThisManyPostsAtATime) * (parseInt(this.startPage) - 1);
      const sliceEnd = parseInt(this.showThisManyPostsAtATime) * parseInt(this.pageView);

      // return this.rawPosts.slice(-5); // dev
      return this.allPosts.slice(sliceStart, sliceEnd); // v2

    },
  },
  methods: {

    async getLatestPostsFromDbase() {
      // reset
      this.allPosts = [];
      this.rawPosts = [];
      // api call
      const posts = await readAllPosts(this.uId, this.token);
      // format "post" objects
      if (posts) {
        for (let p of Object.keys(posts)) {
          let n = { id: p, ...posts[p] };
          if (n.type === 'custom') {
            n.src = JSON.parse(n.src);
          }
          this.rawPosts.push(n);
        }
      } // endif

      this.allPosts = this.rawPosts;
      localStorage.setItem('mindmovie_posts', JSON.stringify(this.rawPosts));
      localStorage.setItem('mindmovie_posts_expire', Date.now() + (24 * 60 * 60 * 1000)); // "expires" in 1d
    },

    refreshPosts() {
      console.log('*** starting refreshPosts() ***');
      localStorage.removeItem('mindmovie_posts');
      localStorage.removeItem('mindmovie_posts_expire');
      location.href = '/mm-all';
    },

    loadMore() {
      this.pageView = (parseInt(this.pageView) + 1).toString();
      this.$router.push({ path: this.$route.path, query: { page: this.pageView } });
      // console.log('*** loadmore > pageView ***', this.pageView);
    },


  },
  async created() {
    console.clear();

    // url params
    this.pageView = this.$route.query.page || '1';
    this.startPage = this.$route.query.start || '1';
    if (this.$route.query.page && !this.$route.query.start) {
      this.startPage = this.pageView;
    }

    // check for stored posts
    const storedPosts = JSON.parse(localStorage.getItem('mindmovie_posts'));
    const storedExpire = JSON.parse(localStorage.getItem('mindmovie_posts_expire'));

    // set allPosts (either from localStorage or dbase
    if (storedPosts && storedExpire > Date.now()) { // it's not expired
      this.rawPosts = this.allPosts = storedPosts;
      console.log('*** got posts from localStorage ***', this.rawPosts);
    } else { // it is expired
      await this.getLatestPostsFromDbase();
      console.log('*** got posts from dbase ***', this.rawPosts);
    }

  },
}
</script>

<template>
  <div id="page-mm-all" class="py-8 px-8 bg-red-lighten-4">
    <h1>All MindMovie Posts</h1>

    <div id="refresh-menu" class="d-flex justify-end">
      <v-btn @click.prevent="refreshPosts" color="blue-lighten-2" class="text-lowercase">refresh</v-btn>
    </div>


    <div id="all-posts-container" class="d-flex flex-wrap justify-space-between">
      <div v-for="post of postsToDisplay" :key="post.id"
           class="pa-3 my-8"
           style="border: 1px solid white; width: 350px;"
      >
        <MindMovieLazySinglePost :post="post" :threshold="1600"  />
      </div>
    </div>






    <div id="load-more-menu" class="d-flex justify-center">
      <v-btn @click.prevent="loadMore" color="blue-lighten-2" class="text-lowercase" density="compact">load more</v-btn>
    </div>

  </div>
</template>

<style scoped lang="scss">
#mm-all {}
</style>
